// 设备状态
export const sbstate = [
  {
    label: "待用",
    value: "待用",
    color: "#FF4A4F",
  },
  {
    label: "启用",
    value: "启用",
    color: "#2BD4B2",
  },
  {
    label: "停用",
    value: "停用",
    color: "#FF4A4F",
  },
  {
    label: "锁定",
    value: "锁定",
    color: "#FF4A4F",
  },
  {
    label: "报废",
    value: "报废",
    color: "#FF4A4F",
  },
];
// 生产线
export const sccodes = [
  {
    value: 1,
    label: 1,
  },
  {
    value: 2,
    label: 2,
  },
  {
    value: 3,
    label: 3,
  },
  {
    value: 4,
    label: 4,
  },
  {
    value: 5,
    label: 5,
  },
  {
    value: 6,
    label: 6,
  },
  {
    value: 7,
    label: 7,
  },
  {
    value: 8,
    label: 8,
  },
  {
    value: 9,
    label: 9,
  },
  {
    value: 10,
    label: 10,
  },

];
// 电子秤型号
export const LectronicWeigherModels = [
  {
    value: 0,
    label: "A",
  },
  {
    value: 1,
    label: "B",
  },
  {
    value: 2,
    label: "C",
  },
];
// 打印面膜数
export const SamePrintCottonMoldCounts = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
];
// 在线状态
export const onlineState = [
  {
    value: 0,
    label: "离线",
    color: "#FF4A4F",
  },
  {
    value: 1,
    label: "在线",
    color: "#2BD4B2",
  },
];
// 发布类型
export const releaseScopes = [
  {
    value: 0,
    label: "黑名单",
  },
  {
    value: 1,
    label: "白名单",
  },
];
// 录入状态
export const mdtypes = [
  {
    value: 0,
    label: "已录入",
  },
  {
    value: 1,
    label: "未录入",
  },
];
// 升级状态
export const upgradeTypes = [
  {
    value: 0,
    label: "否",
  },
  {
    value: 1,
    label: "是",
  },
];
// 归档状态
export const archiveTypes = [
  {
    value: 0,
    label: "未归档",
  },
  {
    value: 1,
    label: "归档中",
  },
  {
    value: 2,
    label: "归档成功",
  },
  {
    value: 3,
    label: "归档失败",
  },
];
// 程序类型
export const softtypes = [
  {
    label: "主程序",
    value: 0,
  },
  {
    label: "升级程序",
    value: 1,
  },
];
// 组合
export const ProcessingTypeAuths = [
  {
    label: "0",
    value: 0,
    children: [1, 2, 3, 5],
  },
  {
    label: "1",
    value: 1,
    children: [2, 4, 5],
  },
  {
    label: "2",
    value: 2,
    children: [6, 7],
  },
  {
    label: "3",
    value: 3,
    children: [1, 2, 3, 4, 5, 6, 7],
  },
  {
    label: "4",
    value: 4,
    children: [4],
  },
  {
    label: "5",
    value: 5,
    children: [2, 5],
  },
  {
    label: "6",
    value: 6,
    children: [1, 3],
  },
];
export const BatchBaleCountPlusOnes = [
  {
    value: false,
    label: "否",
  },
  {
    value: true,
    label: "是",
  },
];
export const TraceModes = [
  {
    label: "关闭",
    value: 0,
  },
  {
    label: "自动",
    value: 1,
  },
  {
    label: "手动",
    value: 2,
  },
];

export const ScreenScrollWays = [
  {
    label: "上下滚动",
    value: 0,
  },
  {
    label: "左右滚动",
    value: 1,
  },
];
export const ScreenModels = [
  {
    label: "中航 ZH-XM",
    value: "中航 ZH-XM",
  },
];
export const BrandModels = [
  {
    label: "不刷唛",
    value: "不刷唛",
  },
  {
    label: "智棉刷唛-打印追溯卡号",
    value: "智棉刷唛-打印追溯卡号",
  },
  {
    label: "智棉刷唛-不打印追溯卡号",
    value: "智棉刷唛-不打印追溯卡号",
  },
  {
    label: "中科刷唛",
    value: "中科刷唛",
  },
];
export const SalesModels = [
  {
    label: "销售",
    value: "销售",
  },
  {
    label: "租赁",
    value: "租赁",
  },
];
export const ProductTypes = [
  {
    label: "一体机",
    value: "一体机",
  },
  {
    label: "框架",
    value: "框架",
  },
  {
    label: "快速",
    value: "快速",
  },
  {
    label: "郑州所",
    value: "郑州所",
  },
  {
    label: "其他",
    value: "其他",
  },
];
export const ControllerTypes = [
  {
    label: "中科",
    value: "中科",
  },
  {
    label: "自研",
    value: "自研",
  },
  {
    label: "快速",
    value: "快速",
  },
  {
    label: "郑州所",
    value: "郑州所",
  },
  {
    label: "其他",
    value: "其他",
  },
];
export const IsBrands = [
  {
    value: true,
    label: "是",
  },
  {
    value: false,
    label: "否",
  },
];
export const Shifts = [1, 2, 3, 4, 5, 6, 7, 8, 9];

export const ForeignFibers = [
  {
    label: "无",
    value: 0,
  },
  {
    label: "低",
    value: 1,
  },
  {
    label: "中",
    value: 2,
  },
  {
    label: "高",
    value: 3,
  },
];
export const CribNos = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
  {
    label: "6",
    value: 6,
  },
  {
    label: "7",
    value: 7,
  },
  {
    label: "8",
    value: 8,
  },
  {
    label: "9",
    value: 9,
  },
];
export const operationTypes = [
  {
    label: "设备管理",
    value: "设备管理",
  },
  {
    label: "参数管理",
    value: "参数管理",
  },
  {
    label: "升级管理",
    value: "升级管理",
  },
  {
    label: "数据管理",
    value: "数据管理",
  },
  {
    label: "登录信息",
    value: "登录信息",
  },
  {
    label: "质量追溯",
    value: "质量追溯",
  },
];
export const operationTypesLog = [
  {
    label: "设备登录信息",
    value: "设备登录信息",
  },
  {
    label: "用户登录信息",
    value: "用户登录信息",
  },
  {
    label: "启停信息",
    value: "启停信息",
  },
  {
    label: "注册信息",
    value: "注册信息",
  },
  {
    label: "激活信息",
    value: "激活信息",
  },
  {
    label: "参数变更",
    value: "参数变更",
  },
  {
    label: "条码补打",
    value: "条码补打",
  },
  {
    label: "数据导出",
    value: "数据导出",
  },
];
export const scxs = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
  {
    label: "6",
    value: 6,
  },
  {
    label: "7",
    value: 7,
  },
  {
    label: "8",
    value: 8,
  },
  {
    label: "9",
    value: 9,
  },
];
export const ljlxs = [
  {
    label: "LAN",
    value: "LAN",
  },
  {
    label: "WLAN",
    value: "WLAN",
  },
];
export const datastate = [
  {
    label: "正常",
    value: "正常",
  },
  {
    label: "异常",
    value: "异常",
  },
];
export const yzstate = [
  {
    label: "成功",
    value: "成功",
  },
  {
    label: "失败",
    value: "失败",
  },
];
export const yxxw = [
  {
    label: "高",
    value: 3,
  },
  {
    label: "中",
    value: 2,
  },
  {
    label: "低",
    value: 1,
  },
  {
    label: "无",
    value: 0,
  },
];
export const shangbzt = [
  {
    label: "上报成功",
    value: "上报成功",
  },
  {
    label: "上报失败",
    value: "上报失败",
  },
];
export const jglx = [
  {
    label: "锯齿细绒棉",
    value: 1,
  },
  {
    label: "皮辊细绒棉",
    value: 2,
  },
  {
    label: "锯齿机采棉",
    value: 3,
  },
  {
    label: "长绒棉",
    value: 4,
  },
  {
    label: "皮辊机采棉",
    value: 5,
  },
  {
    label: "棕彩细绒棉",
    value: 6,
  },
  {
    label: "绿彩细绒棉",
    value: 7,
  },
];
export const com1_9 = [
  {
    label:'COM1',
    value:'COM1'
  },
  {
    label:'COM2',
    value:'COM2'
  },
  {
    label:'COM3',
    value:'COM3'
  },
  {
    label:'COM4',
    value:'COM4'
  },
  {
    label:'COM5',
    value:'COM5'
  },
  {
    label:'COM6',
    value:'COM6'
  },
  {
    label:'COM7',
    value:'COM7'
  },
  {
    label:'COM8',
    value:'COM8'
  },
  {
    label:'COM9',
    value:'COM9'
  }
]
export const baudRate = [
  {
    label: 2400,
    value: 2400
  },
  {
    label: 4800,
    value: 4800
  },
  {
    label: 9600,
    value: 9600
  },
  {
    label: 19200,
    value: 19200
  },
  {
    label: 38400,
    value: 38400
  },
  {
    label: 115200,
    value: 115200
  }
]
export const heatups = [
  {
    label: '开启',
    value: 1
  },
  {
    label: '关闭',
    value: 0
  }
]
// 设备类型
export const deviceType = [
  {
    value: '0',
    label: '打码机',
  },
  {
    value: '1',
    label: '电子秤',
  },
  {
    value: '2',
    label: '电源控制板',
  },
  {
    value: '3',
    label: '回潮接收仪',
  },
  {
    value: '4',
    label: '喷码控制器',
  }
]
// 设备指令，顺序需与deviceType对应
export const deviceCommand = [
  {
    command: [
      { label: '电源状态', value: '/powerStatus' },
      { label: 'aa', value: '/aa' },
    ]
  },
  {
    command: [
      { label: '暂无命令', value: undefined },
    ]
  },
  {
    command: [
      { label: '电源状态', value: '/powerStatus' },
      { label: 'cc', value: '/cc' },
    ]
  },
  {
    command: [
      { label: '电源状态', value: '/powerStatus' },
      { label: 'dd', value: '/dd' },
    ]
  },
  {
    command: [
      { label: '电源状态', value: '/powerStatus' },
      { label: 'xx', value: '/xx' },
    ]
  }
]
